import React from 'react';
import { TableSelectStyle } from './style';

interface TableSelectProps {
  list: { id: string; name: string }[];
  value: string;
  onChange: (value: string) => void;
}

const TableSelect = (props: TableSelectProps): JSX.Element => {
  const { list, value, onChange } = props;

  return (
    <TableSelectStyle>
      <select value={value || ''} onChange={(e): void => onChange(e.target.value)}>
        <option value="">전체</option>
        {list?.map((option) => {
          return (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          );
        })}
      </select>
    </TableSelectStyle>
  );
};

export default TableSelect;
